import React, { useState, useEffect } from "react";
import moment from "moment";
import { useParams, useLocation } from "react-router-dom";
import Hashtags from "react-highlight-hashtags";
import {
  CONSTANTS,
  LANGUAGE_CODES,
  SOCIAL_SOURCES,
} from "../../../../constants/app-constant";
import Initials from "../../../Shared/Initials";
import {
  formatDate,
  formatFollowersCount,
  getDayDifference,
  getUniqueValuesFromList,
  isLoggedIn,
} from "../../../../utility/common-methods";
import {
  FacebookIcon,
  InstagramIcon,
  LinkIcon,
  VideoPlayIcon,
  FavoriteIcon,
  PlusIcon,
  YoutubePlayIcon,
  TagClose,
  TwitterIcon,
  MenuIcon,
  PinterestIcon,
  TwitterWBIcon,
} from "../../../Icons/icons.component";
import ImageViewer from "../../ImageViewer";
import { httpDelete, httpGet } from "../../../../utility/requestHelper";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import Loader from "../../../Shared/Loader";
import FBLike from "../../../../assets/images/fb-like.png";
import FBLove from "../../../../assets/images/fb-love.png";
import FBCare from "../../../../assets/images/fb-care.png";
import FBHaha from "../../../../assets/images/fb-haha.png";
import FBWow from "../../../../assets/images/fb-wow.png";
import FBSad from "../../../../assets/images/fb-sad.png";
import FBAngry from "../../../../assets/images/fb-angry.png";
import ConceptLogo from "../../../../assets/images/conceptbiu-logo.png";
import VideoThumbnail from "../../../../assets/images/video-thumb-large.svg";
import ShareArticle from "../../../Shared/ShareArticle";
import DownloadFeeds from "../DownloadFeeds";
import HorizontalTabs from "../../../Shared/HorizontalTabs";
import NextPrevArrows from "../NextPrevArrows";
import ArticleTags from "../ArticleTags";
import { TagsListModal } from "../../TagsAndFavourites/Tags/TagsListModal";
const { DATA_NOT_FOUND } = CONSTANTS;
const [likes, dislikes, tweets, comments, views, shares] = [
  "Likes",
  "Dislikes",
  "Retweets",
  "Comments",
  "Views",
  "Shares",
];
const { YOUTUBE, INSTAGRAM, TWITTER, FACEBOOK, PINTEREST, LINKEDIN } =
  SOCIAL_SOURCES;

export default function SocialFeedDetails() {
  const [isLoading, setIsLoading] = useState(true);
  const [showError, setShowError] = useState();
  const { id, channel_type } = useParams();
  const paramsToken = channel_type.split("-");
  const clientId = paramsToken[0];
  const channelType = paramsToken[1];
  const location = useLocation();
  const [feedData, setFeedData] = useState({});
  const [showImgViewer, setShowImgViewer] = useState(false);
  const [firstImageToShow, setFirstImageToShow] = useState(0);
  const [imgSrcArray, setImageSrcArray] = useState([]);
  const [activeTab, setActiveTab] = useState(null);
  const [feedComments, setFeedComments] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [showAddTagListModal, setShowAddTagListModal] = useState(false);

  useEffect(() => {
    if (id && channelType && clientId) {
      getFeedDetails();
      getFeedComments();
    }
  }, [id, channelType, clientId]);

  useEffect(() => {
    if (feedData) {
      setTagsList(feedData.tags);
    }
  }, [feedData]);

  const getFeedDetails = () => {
    setIsLoading(true);
    httpGet(
      `${unifiedEnvConfig.SOCIAL_FEED_DETAILS.replace("{id}", id).replace(
        "{channel_type}",
        channelType
      )}?client_id=${clientId}`
    ).then((response) => {
      setIsLoading(false);
      const {
        data: { data },
      } = response;
      setFeedData(data);
    });
  };

  const getFeedComments = () => {
    const commentsUrl = unifiedEnvConfig.COMMENTS.replace(
      "{feedId}",
      id
    ).replace("{channel_type}", channelType);
    httpGet(commentsUrl).then((res) => {
      const resObj = res && res.data;
      if (resObj.status == 200) {
        setFeedComments(resObj.data);
      }
    });
  };
  const {
    share_count,
    comment_count,
    reaction_count,
    dislike_count,
    page_details,
    attachments,
    permalink,
    user_followers_count,
    created_at,
    message,
    lang,
    media_type,
    media_link,
    thumbnail_link,
    tonality,
    name,
    title,
    view_count,
    from_username,
    reaction_metadata,
  } = feedData || {};

  const socialDetailsTabs = [
    {
      label: `${likes} (${
        channelType == FACEBOOK ? reaction_count : feedData.like_count
      })`,
      id: likes,
      show: channelType != PINTEREST,
      disableClick:
        channelType == YOUTUBE ||
        channelType == TWITTER ||
        channelType == INSTAGRAM ||
        channelType == 10 ||
        channelType == LINKEDIN,
    },
    {
      label: `${tweets} (${share_count})`,
      id: tweets,
      show: channelType == TWITTER,
      disableClick: true,
    },
    {
      label: `${dislikes} (${dislike_count})`,
      id: dislikes,
      show: channelType == YOUTUBE,
      disableClick: true,
    },
    {
      label: `${comments} (${comment_count})`,
      id: comments,
      show: true,
      disableClick: channelType != YOUTUBE,
    },
    {
      label: `${views} (${view_count})`,
      id: views,
      show: channelType == YOUTUBE,
      disableClick: true,
    },
    {
      label: `${shares} (${share_count})`,
      id: shares,
      show: channelType == FACEBOOK,
      disableClick: true,
    },
    {
      label: `${shares} (${share_count})`,
      id: shares,
      show: channelType == 10,
      disableClick: true,
    },
  ];
  const { display_picture = "" } = page_details || {};

  const getAddedTag = (tags) => {
    setTagsList(getUniqueValuesFromList([...tagsList, ...tags], "tag_id"));
  };

  const renderTags = () => {
    if (tagsList && tagsList.length) {
      return tagsList.map((tag) => {
        const tagName = tag.tag_name || tag.name;
        return (
          <>
            <span className="tagName">
              {tagName}
              <span
                onClick={() => removeTagFromList(tag.tag_id)}
                className="tagClose"
              >
                <TagClose />
              </span>
            </span>
          </>
        );
      });
    }
    return null;
  };

  const removeTag = (tagObject) => {
    httpDelete(
      `${unifiedEnvConfig.DELETE_TAG_FROM_FEED.replace(
        "{id}",
        id
      )}?client_id=${clientId}`,
      tagObject
    ).catch((err) => {
      console.log(err);
      alert("Couldn't delete the tag.");
    });
  };

  const removeTagFromList = (tagId) => {
    const tagObject = tagsList
      .filter((i) => i.tag_id == tagId)
      .map((item) => {
        return {
          tag_id: item.tag_id,
          social_feed_id: id,
          channel_type: channelType,
        };
      });
    setTagsList(tagsList.filter((i) => i.tag_id != tagId));
    removeTag(tagObject[0]);
  };

  const showMediaAttachments = () => {
    return Array.isArray(attachments) && attachments.length
      ? attachments.map((src, index) => {
          if (!src) {
            return null;
          }
          const { media_link, media_type } = src;
          if (media_type === "image") {
            return (
              <div className={`${"imgThumb largeArticleImage"} `}>
                <img
                  onClick={(e) => handleImageZoom(e, attachments, index)}
                  alt={""}
                  key={src}
                  src={media_link}
                />
              </div>
            );
          }
          if (media_type === "animated_gif") {
            return (
              <div className={`${"imgThumb largeArticleImage"} `}>
                <img
                  onClick={(e) => handleImageZoom(e, attachments, index)}
                  alt={""}
                  key={src}
                  src={media_link}
                />
              </div>
            );
          }
          if (media_type === "video") {
            return (
              <div className="videoThumb">
                <VideoPlayIcon />
                <a href={permalink} target="_blank">
                  <img
                    src={media_link}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = VideoThumbnail;
                    }}
                    height="200px"
                    width="200px"
                  />
                </a>
              </div>
            );
          }
          return null;
        })
      : "";
  };

  const showExpireMediaAttachments = () => {
    return Array.isArray(attachments) && attachments.length
      ? feedData.map((src, index) => {
          if (!src) {
            return null;
          }
          const { media_type, media_link, id } = src;
          if (media_type === "image") {
            return (
              <div className={`${"imgThumb largeArticleImage"} `}>
                <img
                  onClick={(e) => handleImageZoom(e, attachments, index)}
                  alt={""}
                  key={src}
                  src={media_link}
                />
              </div>
            );
          }
          if (media_type === "video") {
            let filtered = attachments.filter((row) => row.id === id);
            return (
              <a href={filtered.target_url} target="_blank">
                <img
                  width="320"
                  height="240"
                  src={media_link}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = VideoThumbnail;
                  }}
                />
              </a>
            );
          }
          return null;
        })
      : "";
  };

  const showMedia = () => {
    if (
      channelType == INSTAGRAM ||
      channelType == PINTEREST ||
      channelType == 10 ||
      channelType == LINKEDIN
    ) {
      if (media_type === "image") {
        return (
          <div className={`${"imgThumb largeArticleImage"} `}>
            <img
              src={media_link}
              alt={media_link}
              onClick={(e) => handleImageZoom(e, media_link)}
            />
          </div>
        );
      }
      if (media_type === "video") {
        return (
          <div className="videoThumb">
            <VideoPlayIcon />
            <a href={permalink} target="_blank">
              <img
                width="320"
                height="240"
                src={thumbnail_link}
                src={VideoThumbnail}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = VideoThumbnail;
                }}
              />
            </a>
          </div>
        );
      }
    }
    if (channelType == YOUTUBE && thumbnail_link) {
      return (
        <div className="videoThumb">
          <VideoPlayIcon />
          <a href={permalink} target="_blank">
            <img width="320" height="240" src={thumbnail_link} alt="NA" />
          </a>
        </div>
      );
    }
    if (channelType == PINTEREST && thumbnail_link) {
      return (
        <div className="imgThumb largeArticleImage">
          <img
            src={thumbnail_link}
            alt={thumbnail_link}
            onClick={(e) => handleImageZoom(e, thumbnail_link)}
          />
        </div>
      );
    }
  };

  const renderOnlineDetails = () => {
    return (
      <>
        <p>
          <label>Reaction:</label>{" "}
          <span>{reaction_count || DATA_NOT_FOUND}</span>
        </p>
        <p>
          <label>Share:</label> <span>{share_count || DATA_NOT_FOUND}</span>
        </p>
        <p>
          <label>Page:</label>{" "}
          <span>{(page_details && page_details.name) || DATA_NOT_FOUND}</span>
        </p>
        <p>
          <label>Tonality:</label> <span>{tonality || DATA_NOT_FOUND}</span>
        </p>
        <p>
          <label>Date:</label>{" "}
          <span>{formatDate(created_at) || DATA_NOT_FOUND}</span>
        </p>
      </>
    );
  };

  const handleImageZoom = (e, articleImages, index) => {
    const imageArray = [];
    Array.isArray(articleImages) && articleImages.length
      ? articleImages.forEach(({ media_link = "" }) => {
          imageArray.push(media_link);
        })
      : imageArray.push(articleImages);
    setImageSrcArray(imageArray);
    setShowImgViewer(true);
    setFirstImageToShow(index);
  };

  const gotoPermalink = () => {
    if (!permalink) return;
    window.open(permalink, "_blank");
  };

  const getEntityName = () => {
    const currentEntityName = location.search.split("entityName=")[1];
    const tempString = decodeURIComponent(currentEntityName);
    return currentEntityName
      ? decodeURIComponent(tempString.substring(1, tempString.length - 1))
      : null;
  };
  const pageTitle =
    channelType == YOUTUBE
      ? name
      : channelType == TWITTER
      ? `@${from_username}`
      : channelType == LINKEDIN || channelType == 10
      ? from_username
      : channelType == PINTEREST
      ? from_username
      : page_details && page_details.name;

  const {
    angry_count = 0,
    care_count = 0,
    haha_count = 0,
    like_count = 0,
    sad_count = 0,
    wow_count = 0,
    love_count = 0,
  } = reaction_metadata || {};

  return (
    <>
      <div className="mainContainer newsDetailsContainer socialDetailsContainer">
        {isLoading && (
          <div style={{ marginTop: "15%", position: "relative" }}>
            {" "}
            <Loader />
          </div>
        )}
        <div className="dashboardHeader">
          <div className="dashboardHeaderTop d-flex">
            <div className="dashboardMobileMenu">
              <button className="btn menuBtn" id="menuBtn">
                <MenuIcon />
              </button>
              <img src={ConceptLogo} width="32" height="32" />
            </div>
          </div>
        </div>
        {!isLoading && (
          <div
            className={`${"newsDetailsWrap printDetailsWrap feedDetailsWrap socialDetailsWrap"} `}
          >
            <div className="newsItemTopWrap">
              <div className="newsItemTop">
                <div className="nitLeft">
                  <div className="sfImageNameWrap">
                    {display_picture && (
                      <span className="sfImage">
                        <img src={display_picture} alt="NA" />
                      </span>
                    )}
                    <div className="sfNameFollow">
                      <h2 className="sfNameFollow">{pageTitle}</h2>

                      <span class="sfFollowersCount">
                        {user_followers_count &&
                          `${formatFollowersCount(
                            user_followers_count
                          )} Followers`}
                      </span>
                    </div>
                  </div>
                  <span className="newsDate">
                    {`${moment(created_at).format("dddd Do MMMM, YYYY")}`}
                  </span>
                </div>
                <div className="d-flex nitRight">
                  <button
                    onClick={gotoPermalink}
                    className="btn linkIcon optionBtn"
                  >
                    <div className="hasTooltip">
                      <LinkIcon />
                      <span className="tooltipWrap left">Go to Page</span>
                    </div>
                  </button>
                  {isLoggedIn() && (
                    <button className="btn optionBtn">
                      <div className="hasTooltip">
                        <ShareArticle
                          client_id={clientId}
                          article={[feedData]}
                          channel_type={channelType}
                          isSocial
                        />
                        <span className="tooltipWrap center">Share</span>
                      </div>
                    </button>
                  )}
                  {/* TODO: Hide till download is not available
                  <div className="downloadBtnWithText optionBtn">
                    <DownloadFeeds hideText hideFormats />
                  </div> */}
                  {isLoggedIn() && (
                    <>
                      <ArticleTags
                        article={feedData}
                        hideTheme
                        callSocialAPI
                        showFavouriteTag
                        hideTonality
                        isSocial
                        showTicket={false}
                      />

                      <ArticleTags
                        article={feedData}
                        hideTheme
                        callSocialAPI
                        hideFavouriteTag
                        newsDetails
                        isSocial
                        showTicket={true}
                        entityName={getEntityName()}
                      />
                    </>
                  )}
                </div>
              </div>
              <div className="newsItemBottom">
                <div className="nibLeft">
                  <span className="newsDate">
                    {`${moment(created_at).format("dddd Do MMMM, YYYY")}`}
                  </span>
                </div>
                {isLoggedIn() && (
                  <ArticleTags
                    article={feedData}
                    hideTheme
                    callSocialAPI
                    hideFavouriteTag
                    newsDetails
                    isSocial
                    showTicket={false}
                  />
                )}
              </div>
            </div>
            <div className="metaTagsWrap">
              {getEntityName() && (
                <div className="mtWrap">
                  <span className="label-span">Entity:</span>{" "}
                  <span>{getEntityName()}</span>
                </div>
              )}
              <div className="mtWrap">
                <span className="label-span">Platform :</span>{" "}
                {channelType == INSTAGRAM && <InstagramIcon />}
                {channelType == FACEBOOK && <FacebookIcon />}
                {channelType == YOUTUBE && <YoutubePlayIcon />}
                {channelType == TWITTER && <TwitterWBIcon />}
                {channelType == LINKEDIN && (
                  <img
                    src="https://backendportal.conceptbiu.com/assets/article_download/icons8-linkedin-30.png"
                    alt="NA"
                    width={25}
                    height={25}
                  />
                )}
                {/* {channelType == PINTEREST && <PinterestIcon />} */}
              </div>
              <div className="mtWrap">
                <span className="label-span">Language :</span>{" "}
                {LANGUAGE_CODES[lang] != "Other" ? (
                  <span>{LANGUAGE_CODES[lang] || DATA_NOT_FOUND}</span>
                ) : (
                  <span>{"-"}</span>
                )}
              </div>
              {isLoggedIn() && (
                <div className="mtWrap mtAddTag">
                  <span
                    onClick={() => setShowAddTagListModal(true)}
                    className="addTag"
                  >
                    Add Tag <PlusIcon />{" "}
                  </span>
                  <div className="tagList">{renderTags()}</div>
                </div>
              )}
            </div>
            <div className="feedInfoMedia">
              <div className="feedInfo">
                <Hashtags text={message || DATA_NOT_FOUND} />
              </div>
              <div className="feedMedia">
                {showMediaAttachments()}
                {feedData && feedData.length && showExpireMediaAttachments()}
                {(channelType == INSTAGRAM ||
                  // channelType == PINTEREST ||
                  channelType == YOUTUBE ||
                  channelType == 10 ||
                  channelType == LINKEDIN) &&
                  showMedia()}
              </div>
            </div>
            <div className="ltcSection">
              <div className="ltcTab">
                <HorizontalTabs
                  data={socialDetailsTabs}
                  selectedTab={activeTab}
                  setSelectedTab={setActiveTab}
                />
                <div className="tabPanel">
                  {activeTab == likes && channelType == FACEBOOK && (
                    <React.Fragment key={Math.random()}>
                      <div className="fbLikeSection">
                        <div className="fbLikeCounts">
                          <div className="fbcWrap">
                            <img src={FBLike} />
                            <div className="fbText">
                              <label>Likes</label>
                              <span>{like_count}</span>
                            </div>
                          </div>
                          <div className="fbcWrap">
                            <img src={FBLove} />
                            <div className="fbText">
                              <label>Love</label>
                              <span>{love_count}</span>
                            </div>
                          </div>
                          <div className="fbcWrap">
                            <img src={FBCare} />
                            <div className="fbText">
                              <label>Care</label>
                              <span>{care_count}</span>
                            </div>
                          </div>
                          <div className="fbcWrap">
                            <img src={FBHaha} />
                            <div className="fbText">
                              <label>Haha</label>
                              <span>{haha_count}</span>
                            </div>
                          </div>
                          <div className="fbcWrap">
                            <img src={FBWow} />
                            <div className="fbText">
                              <label>Wow</label>
                              <span>{wow_count}</span>
                            </div>
                          </div>
                          <div className="fbcWrap">
                            <img src={FBSad} />
                            <div className="fbText">
                              <label>Sad</label>
                              <span>{sad_count}</span>
                            </div>
                          </div>
                          <div className="fbcWrap">
                            <img src={FBAngry} />
                            <div className="fbText">
                              <label>Angry</label>
                              <span>{angry_count}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                  {activeTab == tweets && <>No retweets found.</>}
                  {activeTab == comments && (
                    <React.Fragment key={Math.random()}>
                      <div className="commentSection">
                        {feedComments && !!feedComments.length ? (
                          feedComments.map((commentItem) => {
                            const { from_username, updated_at, message } =
                              commentItem;
                            return (
                              <div className="commentRow">
                                <div className="cImage">
                                  <img src={ConceptLogo} />
                                </div>
                                <div className="commentInfo">
                                  <div className="ciTop">
                                    <span className="ciName">
                                      {from_username}
                                    </span>
                                    <span className="ciDays">
                                      {`${getDayDifference(
                                        new Date(),
                                        updated_at
                                      )}d`}
                                    </span>
                                  </div>
                                  <p>{message}</p>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <span>No comments found</span>
                        )}
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
            <NextPrevArrows isSocial entityName={getEntityName()} />
          </div>
        )}

        {showError && <div className="404article">{showError}</div>}
        {showImgViewer && (
          <ImageViewer
            firstImageToShow={firstImageToShow}
            imgSrcArray={imgSrcArray}
            setShowImgViewer={setShowImgViewer}
          />
        )}
        {showAddTagListModal ? (
          <TagsListModal
            show={showAddTagListModal}
            onCancel={() => setShowAddTagListModal(false)}
            feedDetail={feedData}
            addedTag={getAddedTag}
          />
        ) : null}
      </div>
    </>
  );
}
